export default __webpack_public_path__ + "static/media/orange-right-arrow.33d96829.svg";